export enum AccountLocatorAccountNameMethod {
Property,
HardCoded,
}
